// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bhm_tr","LeftMenu__link":"ir_b bhm_vt bhm_a bhm_rc","LeftMenu__link__icon":"ir_c"};